export default __webpack_public_path__ + "images/models/b1a829f4d464b25f1fb46dcafbceacc3.usdz";